import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { AppBar, Drawer, RaisedButton, List, ListItem, FlatButton} from 'material-ui';
import { isEmpty } from 'lodash'
import AboutUsButton from './AboutUsButton';
import { TEXT_COLOR, BACKGROUND_COLOR, BUTTON_COLOR } from '../constants/colours'
import language, {languages} from '../constants/languages'
import { setDefaultLanguage } from '../actions/lead'
import { CONTACT_US } from '../constants/common'

const windowWidth = 780 ;

const mainLogoImg = 'images/ascend_logo.png';

const style = {
  flexDiv: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    color: TEXT_COLOR,
    marginRight: 10,
  },
  appBar: {
    position: 'fixed',
    zIndex: '2',
    width: "100%",
    top: 0,
    backgroundColor: BACKGROUND_COLOR,
	  fontFamily: "Open Sans",
  },
  applyButton: {
    margin:10,
  },
  header: {
    paddingLeft: 10,
    color: '#0d73b1',
    fontSize: 22,
  }
};

const HeaderItems = (props) => {
  const secondLang = props.otherLanguage
  return window.innerWidth >= windowWidth && !isEmpty(props.selectedLanguage) &&
  <div style={style.flexDiv}>
    <FlatButton label={languages[secondLang]}
                primary={true} labelStyle = {{color:BUTTON_COLOR}} onClick={() => props.handleChange(secondLang)}/>
    <AboutUsButton selectedLanguage={props.selectedLanguage}/>
    <RaisedButton
      containerElement={<Link to="/products"/>}
      label={language[props.selectedLanguage].product}
      labelColor={TEXT_COLOR}
      style={{margin: 10}}
    />
    <RaisedButton
      containerElement={<Link to="/apply"/>}
      label={language[props.selectedLanguage].apply}
      labelColor="white"
      style={style.applyButton}
      backgroundColor={BUTTON_COLOR}
    />
    <div>
      <i className="fa fa-phone"></i>
      <span style={{paddingLeft: 5}}>{CONTACT_US}</span>
    </div>
  </div>
}

const Logo = () => (
  <div className='flex_item logo'>
    <img src={mainLogoImg} />
    <div/>
    <span style={style.header}>ASCEND CAPITAL</span>
  </div>
);


const LeftMenu = props => {
  const secondLang = props.otherLanguage
  return !isEmpty(props.selectedLanguage) && <List>
    <ListItem
      onClick={() => {
        props.onCategoryClick();
      }}
      key={1}
      primaryText={language[props.selectedLanguage].product}
      containerElement={<Link to="/products"/>}
    />
    <ListItem onClick={() => {
      props.onCategoryClick();
    }} key={2} primaryText={language[props.selectedLanguage].about_us} containerElement={<Link to="/about_us"/>}/>
    <ListItem
      onClick={() => {
        props.onCategoryClick();
      }}
      key={3}
      primaryText={language[props.selectedLanguage].contact_us}
      containerElement={<Link to="/contact"/>}
    />
    <ListItem
      onClick={() => {
        props.onCategoryClick();
      }}
      key={5}
      primaryText={language[props.selectedLanguage].apply}
      containerElement={<Link to="/apply"/>}
    />
      <ListItem onClick={() => props.handleChange(secondLang)}
                key={6}
                primaryText={languages[secondLang]}
      />
  </List>
}

class Header extends Component {
  state = {
    openMenu: false,
    width: window.innerWidth,
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  toggleMenuDrawer = () => {
    this.setState({
      openMenu: !this.state.openMenu
    });
  }

  closeMenuDrawer = () => {
    this.setState({ openMenu: false });
  }

  handleTitleTouchTap = () => {
    this.props.history.push('/');
  }

  handleChange = (value) => {
    this.props.setDefaultLanguage(value)
  }

  render() {
    const { width } = this.state;
    const isMobile = width < windowWidth;
    return (
      <div>
        <AppBar
          showMenuIconButton={isMobile}
          style={style.appBar}
          zDepth={0}
          title={<Logo/>}
          titleStyle={{ color: TEXT_COLOR, marginTop: 15}}
          className="app-header"
          onTitleClick={() => {
            this.handleTitleTouchTap();
          }}
          onLeftIconButtonClick={() => {
            this.toggleMenuDrawer();
          }}
          iconElementRight={
            <HeaderItems selectedLanguage={this.props.selectedLanguage} handleChange={this.handleChange} otherLanguage={this.props.otherLanguage}/>
          }
        />
        <Drawer open={this.state.openMenu} onRequestChange={openMenu => this.setState({ openMenu })} width={300} docked={false}>
          <AppBar
            style={{
              backgroundColor: BACKGROUND_COLOR
            }}
            title="ASCEND CAPITAL"
            titleStyle={{ color: TEXT_COLOR}}
            onTitleClick={() => {
	            this.handleTitleTouchTap();
	            this.closeMenuDrawer();
            }}
            showMenuIconButton={false}
          />
          <LeftMenu onCategoryClick={this.closeMenuDrawer} selectedLanguage={this.props.selectedLanguage} handleChange={this.handleChange} otherLanguage={this.props.otherLanguage}/>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedLanguage: state.defaultLanguage,
  otherLanguage: state.otherLanguage
});

const mapDispatchToProps = (dispatch) => ({
  setDefaultLanguage: (language) => dispatch(setDefaultLanguage(language))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js